import React from 'react';
import { Grid, Dialog, DialogContent, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SuccessIcon from '@mui/icons-material/CheckCircle';

const useStyles: any = makeStyles(theme => ({
  content: {
    paddingBottom: 6
  },
  statusContainer: {
    width: 554,
    paddingLeft: 4
  },
  status: {
    width: 74,
    margin: 'auto'
  },
  summaryText: {
    textAlign: 'center',
    paddingTop: 16
  },
  success: {
    height: 64,
    width: 64,
    paddingLeft: 14,
    paddingTop: 14,
    backgroundColor: theme.palette.success[50],
    borderRadius: 31,
    '& svg': {
      height: 34,
      width: 34,
      color: theme.palette.success[600]
    }
  },
  messagesDisplay: {
    paddingTop: 8,
    textAlign: 'center',
    '& span': {
      paddingTop: 8,
      display: 'block'
    }
  },
  actions: {
    display: 'flex',
    padding: '16px 24px',
    justifyContent: 'center',
    '& button:first-child': {
      marginRight: 16
    }
  }
}));

type AccountBalanceTrasferConfirmationModalProps = {
  close: (o: boolean) => void;
  isOpen: boolean;
};

export const AccountBalanceTrasferConfirmationModal: React.FC<
  AccountBalanceTrasferConfirmationModalProps
> = ({ isOpen, close }) => {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogContent className={classes.content}>
        <Grid container>
          <Grid item>
            <div className={classes.statusContainer}>
              <div className={classes.status}>
                <div className={classes.success}>
                  <SuccessIcon />
                </div>
              </div>
              <div className={classes.summaryText}>
                <Typography variant="h5">
                  Refund to Account Balance Confirmation
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item sm={12}>
            <div className={classes.messagesDisplay}>
              <Typography variant="body4"></Typography>
              <Typography variant="body4">
                Once Acknowledged, this refund will be applied to the client's
                account balance.
              </Typography>
              <Typography variant="body4">
                Acknowledge the confirmation or Cancel to return to the refund
                process.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <div className={classes.actions}>
        <Button color="primary" variant="outlined" onClick={() => close(false)}>
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={() => close(true)}>
          Acknowledge
        </Button>
      </div>
    </Dialog>
  );
};
